/* @ngInject */
function RepositoryController ($scope, $rootScope, $timeout, $state) {
  $scope.pricing = {
    organized: {
      access: true,
      pricingPlan: 'Pro'
    }
  }

  const api = {
    _getInitialData
  }

  this.getApi = () => api

  function activate () {
    $scope.usedIn = $state.params.usedInModule
    api._getInitialData()
  }

  activate()

  $scope.handleMenuPress = function (pageId, usedIn) {
    switch (pageId) {
      case 1:
        $state.go('repository.recents', {}, { reload: true })
        break
      case 2:
        $state.go('repository.all', {}, { reload: true })
        break
      case 3:
        $state.go('repository.organized', {}, { reload: true })
        break
      case 4:
        $state.go('repository.used-in', { usedInModule: usedIn }, { reload: true })
        break
      case 5:
        $state.go('repository.trash', {}, { reload: true })
        break
      case 6:
        $state.go('repository.shared', {}, { reload: true })
        break
    }

    $timeout(() => {
      $scope.selectedMenuId = pageId
      $scope.usedIn = usedIn
    })
  }

  function _getInitialData () {
    Promise.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures(),
      $rootScope.getUser()
    ]).then(([{ features }, companyFeatures, user]) => {
      const hasOrganized = !!features['REPOSITORIES.ORGANIZED']

      $scope.pricing.organized.access = hasOrganized
      $scope.features = features
      $scope.showSharedItem = (features['SHARE.GUEST'] || companyFeatures.includes('GUEST_ASSET_PACK')) && $rootScope.isUserSysAdminAdmin(user)
    })
  }
}

export { RepositoryController }
